"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LogLevel;
(function (LogLevel) {
    LogLevel["INFO"] = "INFO";
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["WARN"] = "WARN";
    LogLevel["ERROR"] = "ERROR";
    LogLevel["LOG"] = "LOG";
})(LogLevel || (LogLevel = {}));
exports.default = LogLevel;
//# sourceMappingURL=LogLevel.js.map